import $ from 'jquery'

( () => {
  $('.menu-left').on('click', () => {
		$('.menu-body').toggleClass('active')
  })
})()